<template>
  <div>
    <div class="invite-modal-button" :style="{ color: getPrimaryColor() }" @click="showModal">
      Invite others
    </div>
    <a-modal v-model="visible" width="100%" height="100vh" :centered="true" :footer="null" :bodyStyle="{ padding: 0, display: 'flex', justifyContent: 'center' }">
      <div class="invite-page-container">
        <img class="invite-side-image" src="../../assets/images/invite-side-img.png" alt="side-image" />
        <div class="invite-right-side-container">
          <div>
            <p class="text-invite">Invite people to</p>
            <p class="text-invite-title">{{ circle_title }} {{ !circle_title.toLowerCase().includes("circle") ? " Circle" : "" }}</p>
            <p class="text-feild-subtitle">
              Include this link in personal emails and social media post to invite your friends.
            </p>
            <div class="invite-input-container">
              <input class="invite-input" disabled v-model="inviteLink" />
              <div class="invite-copy-link-button" :style="{ color: getPrimaryColor() }" v-clipboard:copy="inviteLink" v-clipboard:success="onCopy" v-clipboard:error="onError">
                Copy Link
              </div>
            </div>
            <div class="invite-copy-link-button2" :style="{ color: getPrimaryColor() }" v-clipboard:copy="inviteLink" v-clipboard:success="onCopy" v-clipboard:error="onError">
              Copy Link
            </div>
            <div class="invite-divider-container">
              <div class="invite-horizontal-divider" />
              <div class="invite-horizontal-divider-text">Or</div>
              <div class="invite-horizontal-divider" />
            </div>
            <div class="social-bottom-container">
              <p class="invite-social-text">Share link on:</p>
              <div class="invite-social-container">
                <div class="invite-social-button" style="background-color: #1877f2">
                  <ShareNetwork network="facebook" :url="inviteLink">
                    <img class="invite-social-icon" src="../../assets/images/social-images/facebook.png" alt="f" />
                  </ShareNetwork>
                </div>
                <div class="invite-social-button" style="background: #000">
                  <ShareNetwork network="twitter" :url="inviteLink">
                    <img class="hw30" src="../../assets/images/social-images/twitter.png" alt="t" />
                  </ShareNetwork>
                </div>
                <div class="invite-social-button" style="background: #2867b2">
                  <ShareNetwork network="linkedin" :url="inviteLink">
                    <img class="invite-social-icon" src="../../assets/images/social-images/linkedin.png" alt="l" />
                  </ShareNetwork>
                </div>
                <div class="invite-social-button" style="background: #e60023">
                  <ShareNetwork network="pinterest" :url="inviteLink">
                    <img class="invite-social-icon" src="../../assets/images/social-images/pinterest.png" alt="p" />
                  </ShareNetwork>
                </div>
                <div class="invite-social-button" style="background: #25d366">
                  <ShareNetwork network="whatsapp" :url="inviteLink">
                    <img style="padding:10px" src="../../assets/images/social-images/whatsapp.png" alt="w" />
                  </ShareNetwork>
                </div>
                <div class="invite-social-button" style="background: #2a71d4">
                  <ShareNetwork network="email" :url="inviteLink">
                    <img class="invite-social-icon" src="../../assets/images/social-images/email.png" alt="e" />
                  </ShareNetwork>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import Vue from "vue"
import VueClipboard from "vue-clipboard2"

Vue.use(VueClipboard)

export default {
  name: "InviteOthersModal",
  data() {
    return {
      visible: false,
      inviteLink: "",
      circle_title: "",
    }
  },

  created() {
    const currentCircle = JSON.parse(localStorage.getItem("currentCircle"))
    this.circle_title = currentCircle.condition_type
    const user = JSON.parse(localStorage.getItem("user"))
    this.authUserId = user.user.id
    this.inviteLink = `${process.env.BASE_APP_URL}circles/all/?user=${this.authUserId}`
  },

  methods: {
    showModal() {
      this.visible = true
    },
    handleOk() {
      this.visible = false
    },
    onCopy(e) {
      this.$notification.success({
        message: "Success",
        description: "Invite Link Copied successfully.",
      })
    },
    onError(e) {
      this.$notification.success({
        message: "Failed",
        description: "Failed to Copy",
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.invite-modal-button {
  font-family: "Lato";
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
  width: 81px;
  margin-top: 24px;
}
.invite-page-container {
  display: flex;
  max-width: 1840px;
  width: 100%;
  height: 100vh;
}

.invite-side-image {
  @media only screen and (max-width: 700px) {
    display: none;
  }
  align-self: center;
  height: 100vh;
  max-height: 1308px;
  flex: 0.25;
  border-radius: 5px 0px 0px 5px;
  object-fit: cover;
}

.invite-right-side-container {
  display: flex;
  @media only screen and (min-width: 701px) {
    flex: 0.75;
  }
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px;
  @media only screen and (max-width: 700px) {
    padding-top: 76px;
    justify-content: flex-start;
  }
}

.text-invite {
  font-family: "Lato";
  font-weight: 400;
  font-size: 24px;
  color: #0f1734;
  line-height: 32px;
  margin: 0px;
}

.text-invite-title {
  font-family: "Lato";
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: #0f1734;
  margin-top: 5px;
}

.text-feild-subtitle {
  font-family: "Lato";
  font-weight: 700;
  font-size: 16px;
  color: #647490;
  margin-top: 48px;
}

.invite-input-container {
  width: 100%;
  background: #f8fafd;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  display: flex;
  padding: 15px;
  @media only screen and (max-width: 700px) {
    height: 40px;
    padding: 0px 10px;
  }
}

.invite-input {
  font-family: "Lato";
  font-weight: 400;
  font-size: 16px;
  color: #94a3b8;
  @media only screen and (max-width: 700px) {
    color: #647490;
  }
  border: none;
  background: none;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}

.invite-copy-link-button {
  @media only screen and (max-width: 700px) {
    display: none;
  }
  font-family: "Lato";
  font-weight: 700;
  font-size: 16px;
  color: #2a71d4;
  text-align: center;
  cursor: pointer;
}
.invite-copy-link-button2 {
  @media only screen and (min-width: 701px) {
    display: none;
  }
  margin-top: 21px;
  font-family: "Lato";
  font-weight: 700;
  font-size: 16px;
  color: #2a71d4;
  text-align: center;
  cursor: pointer;
}

.invite-divider-container {
  display: flex;
  padding: 48px 0px 36px 0px;
  @media only screen and (max-width: 700px) {
    padding: 36px 0px 24px 0px;
  }
}

.invite-horizontal-divider {
  width: 100%;
  height: 20px;
  border-bottom: 1px solid #cbd5e1;
}

.invite-horizontal-divider-text {
  font-family: "Lato";
  font-weight: 400;
  font-size: 16px;
  text-align: center;
  color: #cbd5e1;
  padding: 7px 20px;
  width: 77px;
}

.invite-social-container {
  @media only screen and (min-width: 701px) {
    display: flex;
    justify-content: center;
  }
  @media only screen and (max-width: 700px) {
    display: grid;
    grid-template-columns: auto auto auto;
    align-items: center;
    justify-content: space-between;
  }
  flex-wrap: wrap;
  row-gap: 24px;
}

.social-bottom-container {
  @media only screen and (min-width: 701px) {
    display: flex;
  }
}

.invite-social-text {
  font-family: "Lato";
  font-weight: 700;
  font-size: 16px;
  color: #647490;
  padding-right: 30px;
  margin-top: 15px;
  text-align: left;
  white-space: nowrap;
  @media only screen and (max-width: 700px) {
    margin-bottom: 24px;
    margin-top: 0px;
  }
}

.invite-social-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-right: 20px;
}

.invite-social-icon {
  padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/InviteOthersModal.vue